const engineFitmentFacetTypes = [
  'Engine Family',
  'Engine Version',
  'Displacement',
  'Engine Code',
  'Engine Fuel System',
  'Engine Camshaft Type',
]
export default engineFitmentFacetTypes
